import { Dispatch } from 'redux';
import { getActionApprovalDoc } from '../../graphql/queries';
import api from '../../services/api';
import debug from '../../services/debug';
import {
  GET_APPROVAL_DOCS_COMPLETED,
  GET_APPROVAL_DOCS_FAILED,
  GET_APPROVAL_DOCS_REQUESTED,
} from './types';

type AuthMode = 'iam' | 'userPool';

function getApprovalDocAction(
  ContactID: string,
  ApprovalDocID: string,
  authMode: AuthMode,
) {
  return async function action(dispatch: Dispatch) {
    dispatch({
      type: GET_APPROVAL_DOCS_REQUESTED,
    });

    try {
      const { data } = await api.graphql({
        authMode,
        query: getActionApprovalDoc,
        variables: {
          ContactID,
          ApprovalDocID,
        },
      });

      dispatch({
        type: GET_APPROVAL_DOCS_COMPLETED,
        payload: {
          contacts: [],
          docs: [data?.getActionApprovalDoc],
          partnerDocs: [],
        },
      });
    } catch (err) {
      debug(GET_APPROVAL_DOCS_FAILED, err);

      dispatch({
        type: GET_APPROVAL_DOCS_FAILED,
        payload: err,
      });
    }
  };
}

export default getApprovalDocAction;
